'use client';

import { IconMinus, IconPlus } from '@tabler/icons-react';
import type { CSSProperties, ReactElement } from 'react';
import { Cbutton } from '../Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import {
  XYCHART_ZOOM_MAX,
  XYCHART_ZOOM_MIN,
} from './xychart-constants';
import { XYChartDownloadMenu } from './XYChartDownloadMenu';

const ICON_BTN_SIZE = 32;
const ICON_BTN_ICON_SIZE = 18;
const ICON_BTN_RADIUS = 6;
const ICON_BTN_CONTAINER_STYLE: CSSProperties = {
  width: ICON_BTN_SIZE,
  minWidth: ICON_BTN_SIZE,
};

export interface XYChartControlsProps {
  zoom: number;
  imageExportBusy: boolean;
  hasParsedChart: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onDownloadCsv: () => void;
  onDownloadImage: () => void;
}

export function XYChartControls({
  zoom,
  imageExportBusy,
  hasParsedChart,
  onZoomIn,
  onZoomOut,
  onDownloadCsv,
  onDownloadImage,
}: XYChartControlsProps): ReactElement {
  return (
    <>
      <Cbutton
        rootAttributes={{ "data-el": "Cmarkdownxychart/Controls/ZoomOutTrigger" }}
        icon={IconMinus}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onZoomOut}
        disabled={zoom <= XYCHART_ZOOM_MIN}
      />
      <Cbutton
        rootAttributes={{ "data-el": "Cmarkdownxychart/Controls/ZoomInTrigger" }}
        icon={IconPlus}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onZoomIn}
        disabled={zoom >= XYCHART_ZOOM_MAX}
      />
      <XYChartDownloadMenu
        onDownloadCsv={onDownloadCsv}
        onDownloadImage={onDownloadImage}
        disabled={!hasParsedChart || imageExportBusy}
      />
    </>
  );
}
